import { createFileRoute } from "@tanstack/react-router";
import { EnumGroupsListPage } from "../../../../components/system/EnumGroupsListPage";
import { requireSuperAdmin } from "../../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/data-catalog/enum-groups/")({
  beforeLoad: requireSuperAdmin(),
  component: EnumGroupsListRoute,
});

function EnumGroupsListRoute() {
  return <EnumGroupsListPage />;
}
